import type { ProfileManifest } from "../contracts";
import { KNOWN_PROFILE_VARIABLES, PROFILE_TOKEN_TO_CSS_VARIABLE, type ProfileTokenId } from "../registry/profile-registry";
import { getProfileManifest } from "./theme-resolver";

export interface ResolvedProfiles {
    contentProfile: ProfileManifest<ProfileTokenId>;
    presentationProfile: ProfileManifest<ProfileTokenId>;
}

export function resolveProfiles(
    contentProfileId: string,
    presentationProfileId: string,
): ResolvedProfiles {
    return {
        contentProfile: getProfileManifest(contentProfileId, "content"),
        presentationProfile: getProfileManifest(
            presentationProfileId,
            "presentation",
        ),
    };
}

export function compileProfileStyleVariables(
    contentProfileId: string,
    presentationProfileId: string,
): Record<string, string> {
    const { contentProfile, presentationProfile } = resolveProfiles(
        contentProfileId,
        presentationProfileId,
    );

    return {
        ...compileProfileValues(contentProfile.values),
        ...compileProfileValues(presentationProfile.values),
    };
}

export const KNOWN_PROFILE_STYLE_VARIABLES = KNOWN_PROFILE_VARIABLES;

function compileProfileValues(
    values: Partial<Record<ProfileTokenId, string>>,
): Record<string, string> {
    const compiled: Record<string, string> = {};

    for (const [tokenId, value] of Object.entries(values)) {
        if (typeof value !== "string") continue;
        const cssVariable =
            PROFILE_TOKEN_TO_CSS_VARIABLE[
                tokenId as keyof typeof PROFILE_TOKEN_TO_CSS_VARIABLE
            ];
        if (cssVariable) {
            compiled[cssVariable] = value;
        }
    }

    return compiled;
}
